import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LogOut, LayoutDashboard, Sparkles, Home, BookOpen, ClipboardCheck, FileText, Image, PhoneCall, Calendar as CalendarIcon } from 'lucide-react';
import Logo from '../Components/Images/Bada school logo.png';

export default function Navbar({ IsLoggedIn, onLogout }) {
  const location = useLocation();

  return (
    <>
      <header className="NavigationMenu d-none d-lg-block" style={{ position: 'fixed', width: '100%', top: 0, left: 0, zIndex: 2147483647, background: 'rgba(255, 255, 255, 0.85)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(0, 0, 0, 0.05)' }}>
        <div style={{ width: '100%', maxWidth: '1600px', margin: '0 auto', padding: '0 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          
          {/* Brand Logo and Title */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
            <img src={Logo} alt="School Logo" style={{ height: '48px', width: '48px', borderRadius: '50%', border: '2px solid var(--primary-color)' }} />
            <div>
              <h1 style={{ fontSize: '1.15rem', fontWeight: 800, color: 'var(--text-primary)', margin: 0, fontFamily: 'Poppins', lineHeight: '1.2', display: 'flex', alignItems: 'center', gap: '4px' }}>
                Vamshee Techno <Sparkles size={14} style={{ color: 'var(--secondary-color)' }} />
              </h1>
              <span className="d-none d-sm-block" style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '1px', fontFamily: 'Poppins' }}>Preschool & Primary</span>
            </div>
          </Link>

          {/* Desktop Links */}
          <nav style={{ display: 'flex', alignItems: 'center', gap: '24px' }} className="d-none d-lg-flex">
            <Link to="/" style={linkStyle(location.pathname === '/')}>Home</Link>
            
            <Link to="/Academics" style={linkStyle(location.pathname === '/Academics')}>Academics</Link>

            <Link to="/Admissions" style={linkStyle(location.pathname === '/Admissions')}>Admissions</Link>
            <Link to="/Notice" style={linkStyle(location.pathname === '/Notice')}>Notice Board</Link>
            <Link to="/Calendar" style={linkStyle(location.pathname === '/Calendar')}>Calendar</Link>
            <Link to="/Gallery" style={linkStyle(location.pathname === '/Gallery')}>Gallery</Link>
            <Link to="/Contact" style={linkStyle(location.pathname === '/Contact')}>Contact Us</Link>
          </nav>

          {/* Actions & Menu Toggle */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            
            {/* Desktop-only Action buttons */}
            <div className="d-none d-lg-flex" style={{ alignItems: 'center', gap: '12px' }}>
              {IsLoggedIn ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Link to="/Admin" className="btn-premium btn-premium-secondary" style={{ height: '40px', padding: '0 16px', borderRadius: '12px' }}>
                    <LayoutDashboard size={16} /> CMS Dashboard
                  </Link>
                  <button onClick={onLogout} className="btn-premium btn-premium-coral" style={{ height: '40px', padding: '0 16px', borderRadius: '12px' }}>
                    <LogOut size={16} /> Logout
                  </button>
                </div>
              ) : (
                <Link to="/Apply" className="btn-premium btn-premium-primary" style={{ height: '42px', padding: '0 20px', textDecoration: 'none', borderRadius: '12px' }}>
                  Apply Now
                </Link>
              )}
            </div>
          </div>

        </div>
      </header>

      {/* Mobile Bottom Navigation Bar */}
      <div 
        className="d-lg-none" 
        style={{ 
          position: 'fixed', 
          bottom: 0, 
          left: 0, 
          right: 0, 
          backgroundColor: 'rgba(255, 255, 255, 0.95)', 
          backdropFilter: 'blur(12px)', 
          WebkitBackdropFilter: 'blur(12px)', 
          borderTop: '1px solid var(--border-color)', 
          display: 'flex', 
          justifyContent: 'space-around', 
          alignItems: 'center', 
          padding: '8px 0', 
          zIndex: 2147483647,
          boxShadow: '0 -4px 16px rgba(0,0,0,0.06)'
        }}
      >
        <Link to="/" style={mobileNavItemStyle(location.pathname === '/')}>
          <Home size={18} />
          <span style={{ fontSize: '0.6rem', fontWeight: 800, marginTop: '2px' }}>Home</span>
        </Link>
        <Link to="/Academics" style={mobileNavItemStyle(location.pathname === '/Academics')}>
          <BookOpen size={18} />
          <span style={{ fontSize: '0.6rem', fontWeight: 800, marginTop: '2px' }}>Academics</span>
        </Link>
        <Link to="/Admissions" style={mobileNavItemStyle(location.pathname === '/Admissions')}>
          <ClipboardCheck size={18} />
          <span style={{ fontSize: '0.6rem', fontWeight: 800, marginTop: '2px' }}>Admissions</span>
        </Link>
        <Link to="/Notice" style={mobileNavItemStyle(location.pathname === '/Notice')}>
          <FileText size={18} />
          <span style={{ fontSize: '0.6rem', fontWeight: 800, marginTop: '2px' }}>Notice</span>
        </Link>
        <Link to="/Calendar" style={mobileNavItemStyle(location.pathname === '/Calendar')}>
          <CalendarIcon size={18} />
          <span style={{ fontSize: '0.6rem', fontWeight: 800, marginTop: '2px' }}>Calendar</span>
        </Link>
        <Link to="/Gallery" style={mobileNavItemStyle(location.pathname === '/Gallery')}>
          <Image size={18} />
          <span style={{ fontSize: '0.6rem', fontWeight: 800, marginTop: '2px' }}>Gallery</span>
        </Link>
        <Link to="/Contact" style={mobileNavItemStyle(location.pathname === '/Contact')}>
          <PhoneCall size={18} />
          <span style={{ fontSize: '0.6rem', fontWeight: 800, marginTop: '2px' }}>Contact</span>
        </Link>
      </div>
    </>
  );
}

// Inline Styles
const linkStyle = (active) => ({
  color: active ? 'var(--primary-dark)' : 'var(--text-primary)',
  textDecoration: 'none',
  fontSize: '0.98rem',
  fontWeight: active ? 800 : 700,
  transition: 'color var(--transition-fast)',
  fontFamily: 'Quicksand'
});



const mobileNavItemStyle = (active) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: active ? 'var(--primary-dark)' : 'var(--text-secondary)',
  textDecoration: 'none',
  fontFamily: 'Quicksand',
  transition: 'color 0.2s ease',
  flex: 1
});
